// color variables

const colors = {}

export default colors
